import { render, staticRenderFns } from "./virtual-tree-node.vue?vue&type=template&id=45a3eed5"
import script from "./virtual-tree-node.vue?vue&type=script&lang=js"
export * from "./virtual-tree-node.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports